import * as React from 'react';
import {Svg, 
  Path,
  Circle,
  G,
  Defs,
  RadialGradient,
  Stop,
} from 'react-native-svg';

const EmptyReadings = props => {
  return (
    <Svg
      width={204}
      height={177}
      viewBox="0 0 204 177"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        opacity={0.05}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M155.724 12.698c-40.977 15.89-71.167 23.928-73.467 18.734-1.815-4.102 14.167-15.528 40.324-29.829-8.532-1.43-17.439-1.932-26.564-1.39C48.077 3.065 9.541 33.861.837 72.814 45.573 54.997 79.343 45.637 81.78 51.142 84.424 57.115 49.315 78.628 0 101.926c1.25 7.625 3.63 14.897 6.986 21.698C56.806 103.1 95.72 91.807 98.344 97.732c2.532 5.722-29.573 25.701-75.623 47.849 6.348 6.44 13.77 12.047 22.02 16.633a1077.665 1077.665 0 0115.705-7.101c61.334-27.149 113.528-43.569 116.58-36.674 2.857 6.454-38.37 31.055-93.97 56.445a118.567 118.567 0 0023.406.905c54.719-3.255 97.184-42.914 97.026-89.556-30.743 10.93-52.019 15.787-53.934 11.46-2.033-4.592 18.24-18.364 50.125-35.072-2.294-6.999-5.573-13.611-9.695-19.729-49.725 20.473-88.542 31.729-91.161 25.811-2.468-5.575 27.953-24.688 72.116-46.154a100.32 100.32 0 00-15.215-9.85z"
        fill="url(#paint0_radial_1811_18906)"
      />
      <Circle
        cx={129.34}
        cy={19.3012}
        r={6.29801}
        stroke="#4499D2"
        strokeWidth={2}
      />
      <Circle
        cx={129.34}
        cy={58.2239}
        r={3.05445}
        stroke="#4499D2"
        strokeWidth={2}
      />
      <Circle
        cx={38.5208}
        cy={33.8972}
        r={3.05445}
        stroke="#4499D2"
        strokeWidth={2}
      />
      <Path
        d="M143.287 134.258a14.659 14.659 0 009.134-4.068l4.989-51.018c-.075-.502-.152-1.004-.232-1.506l-.381-2.387a15.807 15.807 0 00-15.61-13.316H91.745c-1.222-6.29-6.76-11.037-13.406-11.037H64.712c-8.065 0-14.859 6.026-15.82 14.034l-1.62 13.493a144.09 144.09 0 001.318 43.077 15.63 15.63 0 0014.26 12.781l9.003.644a432.377 432.377 0 0061.694 0l9.74-.697z"
        fill="#C3CCD9"
      />
      <Circle
        cx={50.298}
        cy={72.8197}
        r={6.29801}
        stroke="#4499D2"
        strokeWidth={2}
      />
      <Circle
        cx={76.2467}
        cy={100.39}
        r={6.29801}
        stroke="#4499D2"
        strokeWidth={2}
      />
      <Circle
        cx={71.3811}
        cy={84.1724}
        r={3.05445}
        stroke="#4499D2"
        strokeWidth={2}
      />
      <G filter="url(#filter0_d_1811_18906)">
        <Path
          d="M156.596 80.118h-64.4a16.353 16.353 0 00-15.25 10.45l-16.531 43.23s.473.394 2.432.811c5.676 1.208 8.192 1.292 8.192 1.292a432.375 432.375 0 0061.694 0l9.74-.697a14.653 14.653 0 009.134-4.068 34.942 34.942 0 0011.159-14.953l7.43-19.105c3.173-8.16-2.847-16.96-11.602-16.96h-1.998z"
          fill="#E0E4ED"
        />
      </G>
      <Path
        d="M104.795 99.374a9.16 9.16 0 013.1-2.244 9.303 9.303 0 017.528 0 9.16 9.16 0 013.1 2.244 2.235 2.235 0 01.367 2.497 2.266 2.266 0 01-1.318 1.155 2.332 2.332 0 01-2.481-.644 4.608 4.608 0 00-1.553-1.112 4.685 4.685 0 00-3.758 0 4.608 4.608 0 00-1.553 1.112 2.312 2.312 0 01-1.588.763 2.332 2.332 0 01-1.671-.565 2.253 2.253 0 01-.762-1.568 2.235 2.235 0 01.589-1.638zm20.766 0a2.256 2.256 0 00-.589 1.638 2.263 2.263 0 00.762 1.568 2.33 2.33 0 002.543.339c.272-.131.516-.314.716-.537a4.602 4.602 0 011.554-1.112 4.68 4.68 0 013.757 0 4.602 4.602 0 011.554 1.112 2.308 2.308 0 001.587.763 2.33 2.33 0 001.672-.565 2.263 2.263 0 00.762-1.568 2.235 2.235 0 00-.589-1.638 9.174 9.174 0 00-3.101-2.244 9.3 9.3 0 00-7.527 0 9.164 9.164 0 00-3.101 2.244zm-12.46 18.651a16.43 16.43 0 008.941 2.639c3.179 0 6.288-.917 8.941-2.639.503-.34.851-.859.969-1.448a2.263 2.263 0 00-.966-2.335 2.343 2.343 0 00-2.57-.019 11.61 11.61 0 01-6.374 1.901 11.61 11.61 0 01-6.374-1.901 2.367 2.367 0 00-1.736-.316 2.334 2.334 0 00-1.465.969 2.268 2.268 0 00-.335 1.701c.119.589.466 1.108.969 1.448z"
        fill="#8697AB"
      />
      <Defs>
        <RadialGradient
          id="paint0_radial_1811_18906"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 88.0014 -101.744 0 101.744 88.001)">
          <Stop offset={0.720156} stopColor="#3D87BF" />
          <Stop offset={1} stopColor="#3D87BF" stopOpacity={0} />
        </RadialGradient>
      </Defs>
    </Svg>
  );
};

export default EmptyReadings;
